import { parseStored } from 'helpers/date';

/**
 * Turns the report the API answered with into the shape the form works on.
 *
 * The Young Crew edits this shape and the YC Management Board reads it, so both
 * screens build it the same way - the review screen would otherwise have to
 * guess at how the form reads a stored report back.
 */
const buildFormState = (data) => {
  if (!data) return null;

  return {
    yearlyPlan: data.yearlyPlan || [],
    yearlyPlanNew: [],
    yearlyBudget: data.yearlyBudget || [],
    yearlyBudgetNew: [],
    removedFiles: [],
    participatedInGlobalEvents:
      data.participatedInGlobalEvents === undefined ? null : data.participatedInGlobalEvents,
    globalEvents: data.globalEvents || [],
    events: (data.events || []).map((event) => {
      const date = event.registered ? null : parseStored(event.date);

      return {
        key: event.key,
        id: event.id,
        // Only a card added by hand eases in; the ones a stored report came
        // with are already on screen.
        isNew: false,
        registered: !!event.registered,
        eventId: event.eventId,
        name: event.registered ? null : event.name,
        date: date ? date.toDate() : null,
        modeOfDelivery: event.modeOfDelivery,
        participants: event.participants === null ? null : String(event.participants),
        proof: event.proof || [],
        newProof: [],
        removedProofFiles: [],
      };
    }),
  };
};

export default buildFormState;
